import { createAsyncThunk } from "@reduxjs/toolkit";

import jwtDecode from "jwt-decode";

import { LoginType, SetPasswordType } from "../../types/LoginType";
import { LoginRequest, SetPasswordRequest } from "../../api/generated";
import { Decoded } from "../states/AuthState";
import { Api } from "../../api";
import {
  AUTHENTIFICATION_FAILED,
  REQUEST_FAILED,
} from "../../constants/messageConstants";

export const login = createAsyncThunk(
  "login",
  async (loginType: LoginType): Promise<Decoded | any> => {
    const loginRequest: LoginRequest = {
      username: loginType.emailAddress,
      password: loginType.password,
    };
    return Api.Auth.login(loginRequest)
      .then(({ data }) => {
        let decoded: any = jwtDecode(data);
        return {
          username: decoded.username,
          token: data,
          authority: decoded.authorities[0].authority,
          name: decoded.name,
          exp: decoded.exp,
        };
      })
      .catch((error) => {
        if (error.response && error.response.status === 401) {
          throw new Error(AUTHENTIFICATION_FAILED);
        }

        throw new Error(REQUEST_FAILED);
      });
  }
);

export const setPassword = createAsyncThunk(
  "setPassword",
  async (setPasswordType: SetPasswordType) => {
    const setPasswordRequest: SetPasswordRequest = {
      token: setPasswordType.token,
      password: setPasswordType.password,
    };

    return Api.Auth.savePassword(setPasswordRequest).then(({ data }) => {
      return data;
    });
  }
);
